import { render, staticRenderFns } from "./BlockModel.vue?vue&type=template&id=0628c103&scoped=true&lang=pug"
import script from "./BlockModel.vue?vue&type=script&lang=js"
export * from "./BlockModel.vue?vue&type=script&lang=js"
import style0 from "./BlockModel.vue?vue&type=style&index=0&id=0628c103&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0628c103",
  null
  
)

export default component.exports